// Currencies the Bank of Canada Valet API publishes a daily FX{code}CAD rate for,
// plus CAD itself. CAD and USD are listed first; the rest follow alphabetically by name.
const CURRENCIES = [
	{ code: "CAD", name: "Canadian Dollar" },
	{ code: "USD", name: "US Dollar" },
	{ code: "AUD", name: "Australian Dollar" },
	{ code: "BRL", name: "Brazilian Real" },
	{ code: "GBP", name: "British Pound" },
	{ code: "CNY", name: "Chinese Yuan" },
	{ code: "EUR", name: "Euro" },
	{ code: "HKD", name: "Hong Kong Dollar" },
	{ code: "INR", name: "Indian Rupee" },
	{ code: "IDR", name: "Indonesian Rupiah" },
	{ code: "JPY", name: "Japanese Yen" },
	{ code: "MYR", name: "Malaysian Ringgit" },
	{ code: "MXN", name: "Mexican Peso" },
	{ code: "NZD", name: "New Zealand Dollar" },
	{ code: "NOK", name: "Norwegian Krone" },
	{ code: "PEN", name: "Peruvian Sol" },
	{ code: "PLN", name: "Polish Zloty" },
	{ code: "RUB", name: "Russian Ruble" },
	{ code: "SAR", name: "Saudi Riyal" },
	{ code: "SGD", name: "Singapore Dollar" },
	{ code: "ZAR", name: "South African Rand" },
	{ code: "KRW", name: "South Korean Won" },
	{ code: "SEK", name: "Swedish Krona" },
	{ code: "CHF", name: "Swiss Franc" },
	{ code: "TWD", name: "Taiwan Dollar" },
	{ code: "THB", name: "Thai Baht" },
	{ code: "TRY", name: "Turkish Lira" },
	{ code: "VND", name: "Vietnamese Dong" },
];

export default CURRENCIES;
